@if (!_alwaysShowFrame()) {
    <div
        class="lg-dropdown-like table__row__no-hover-focus-only"
        [class.lg-dropdown--condensed]="_condensed"
    >
        @if (_currentValueIcons && _currentValueIcons.length) {
            <div class="lg-dropdown__icons">
                @for (icon of _currentValueIcons; track icon.icon) {
                    <lg-icon
                        [icon]="icon.icon"
                        [class]="icon.iconClass"
                        [inline]="true"
                        title="{{ icon.title }}"
                    />
                }
            </div>
        }
        <div class="lg-dropdown__text">
            {{ textOverride || _currentValueName }}
        </div>
    </div>
}

<div
    class="{{ className || 'lg-dropdown' }} {{ _alignClass }}"
    [class.table__row__hover-focus-only]="!_alwaysShowFrame()"
    [class.lg-dropdown--disabled]="_isDropdownDisabled"
    [class.lg-dropdown--missing]="!_assigned && !emptyAcceptable"
    [class.lg-dropdown--invalid]="!isValid"
    [class.lg-dropdown--active]="_active"
    [class.lg-dropdown--condensed]="_condensed"
    [attr.title]="_getTitle()"
    tabindex="{{ _allowFocus ? 0 : -1 }}"
    lgTableInputNavigator
    [lgMarkFocusOn]="markFocusOn"
>
    @if (_currentValueIcons && _currentValueIcons.length) {
        <div class="lg-dropdown__icons">
            @for (icon of _currentValueIcons; track icon.icon) {
                <lg-icon
                    [icon]="icon.icon"
                    [class]="icon.iconClass"
                    [inline]="true"
                    title="{{ icon.title }}"
                    [lgTooltip]="icon.styledTitle ?? null"
                    lgTooltipClass="lg-tooltip lg-tooltip--simple"
                    [clickable]="!!icon.clickable"
                    (click)="_multiIconClick($event, icon, current)"
                ></lg-icon>
            }
        </div>
    }
    <div class="lg-dropdown__text">
        {{ textOverride || _currentValueName }}
    </div>
    @if (!_hideArrow) {
        <lg-icon icon="icon-arrow-down" class="lg-dropdown__arrow"></lg-icon>
    }
    @if (!_hideArrow) {
        <div style="width: 30px"></div>
    }
</div>
